import { Component, Inject } from '@angular/core';
import { SettingsConfiguration, SignatureSettingsComponent } from 'src/app/common/components/settings/signature-settings/signature-settings.component';
import { EntityManagementLayoutComponent } from "../../../common/layouts/entity-management-layout.component";
import { FormGroup } from '@angular/forms';
import { ButtonComponent, ButtonConfig, ButtonVariant } from "../../../common/components/core/button/button.component";
import { SetUpSettingsConfigurationData } from 'src/app/common/constants/core-constants';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmationModalComponent } from 'src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component';
import { StorageService } from 'src/app/common/services/storage.service';
import { UserEsignatureClient } from 'src/app/common/services/user-esignature.client';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-complete-settings',
    standalone: true,
    templateUrl: './complete-settings.component.html',
    imports: [SignatureSettingsComponent, EntityManagementLayoutComponent, ButtonComponent, MatDialogModule, CommonModule]
})
export class CompleteSettingsComponent {
  readonly formGroup: FormGroup = new FormGroup({});
  readonly settingsConfiguration: SettingsConfiguration = SetUpSettingsConfigurationData;
  readonly buttonConfig: ButtonConfig = {
    variant: ButtonVariant.SECONDARY,
    text: 'Save'
  };
  esignature: string = "";
  confirmEsignature: string ="";
  saveDisable: boolean = true;
  token: string = "";
  refreshToken: string = "";
  user: string = "";

  constructor(
    private storageService: StorageService,
    private esignatureClient: UserEsignatureClient,
    private matDialog: MatDialog,
    private matDialogRef: MatDialogRef<CompleteSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.esignature = this.data.esignature;
    this.confirmEsignature = this.data.confirmEsignature;
  }

  ngOnInit(): void {
    const { token, refreshToken, user } = this.storageService.getAndRemoveLoginData();
    this.token = token;
    this.refreshToken = refreshToken;
    this.user = user;
    this.formGroup.valueChanges.subscribe(() => {
      this.saveDisable = !this.formGroup.valid;
    });
  }

  convertDayToInteger(day: string): number {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = daysOfWeek.indexOf(day);
    return dayIndex;
  }

  convertTimetoInteger(time: string): number {
    const hour = parseInt(time.split(':')[0], 10);
    return hour;
  }

  checkMeridian(meridian: string): boolean {
    return meridian.toLocaleLowerCase() === "am";
  }

  async onSave(): Promise<void> {
      this.formGroup.markAllAsTouched();
      if(this.formGroup.valid && this.formGroup.dirty) {
        this.storageService.resetLoginData(this.token, this.refreshToken, this.user);
        const isEveryWeek = this.formGroup.value.isSendEveryWeek;
        const isDaily = this.formGroup.value.isSendEveryDay;
        const weeklyruntime = isEveryWeek ? this.convertTimetoInteger(this.formGroup.value.sendEveryWeekTime) : undefined; 
        const dailyruntime = isDaily ? this.convertTimetoInteger(this.formGroup.value.sendEveryDayTime) : undefined;
        const weeklyam = isEveryWeek ? this.checkMeridian(this.formGroup.value.sendEveryWeekMeridian) : undefined;
        const dailyam = isDaily ? this.checkMeridian(this.formGroup.value.sendEveryDayMeridian) : undefined;
        const dayofweek = isEveryWeek ? this.convertDayToInteger(this.formGroup.value.sendEveryWeekDay) : undefined;
        try {
          await firstValueFrom(
            this.esignatureClient.createOrUpdateESignature(
              this.esignature,
              this.confirmEsignature,
              this.formGroup.value.pin,
              this.formGroup.value.pinConfirmation,
              this.formGroup.value.isSendEverySignatureRequest,
              isDaily,
              dailyruntime,
              dailyam,
              isEveryWeek,
              weeklyruntime,
              weeklyam,
              dayofweek
            )
          );
          this.matDialogRef.close(true);
        }
        catch(error:any){
          this.matDialog.open(ConfirmationModalComponent, {
            data: {
              title: "Error",
              message: (error as any)?.error,
              buttonText: "OK",
              hideCancelButton: true,
              isError: true,
            },
          });
          return;
        }
    }
  }
}
